export const authActionTypes = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  AUTHENTICATE: 'AUTHENTICATE',
  COLLECT_EXISTING_CASSETTES: 'COLLECT_EXISTING_CASSETTES',
  COLLECT_NEW_CASSETTES: 'COLLECT_NEW_CASSETTES',
  CHECK_USER: 'CHECK_USER',
};
